const NoSearchResult = () => {
  return (
    <div
      style={{
        display: "flex",
        gap: "16px",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path
          d="M10.0526 30.5255C11.5776 31.1536 13.2484 31.5 15 31.5C22.1797 31.5 28 25.6797 28 18.5C28 16.7477 27.6533 15.0764 27.0248 13.5509M5.79789 27.6827C3.45107 25.3309 2 22.0849 2 18.5C2 11.3203 7.8203 5.5 15 5.5C18.5432 5.5 21.7554 6.91754 24.1003 9.21644"
          stroke="#A2A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M24.1924 27.6919L27.7324 31.2319" stroke="#A2A8B0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M31.2677 31.2322C30.2914 30.2559 28.7085 30.2559 27.7322 31.2322C26.7559 32.2085 26.7559 33.7915 27.7322 34.7678L35.7324 42.768C36.7087 43.7443 38.2916 43.7443 39.2679 42.768C40.2442 41.7917 40.2442 40.2088 39.2679 39.2324L31.2677 31.2322Z"
          stroke="#A2A8B0"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3 30.5L27 6.5" stroke="#A2A8B0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      <div
        style={{
          display: "flex",
          gap: "12px",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            font: "600 20px Inter, sans-serif",
            color: "#696F77",
            textAlign: "center",
            letterSpacing: "-0.2px",
          }}
        >
          No items match your search
        </div>
        <div
          style={{
            font: "500 13px Inter, sans-serif",
            color: "#696F77",
            textAlign: "center",
            letterSpacing: "-0.13px",
          }}
        >
          Try with different keyword
        </div>
      </div>
    </div>
  );
};

export default NoSearchResult;
